import { gql } from '@apollo/client';

const DATA_WAREHOUSE_IMPORTS = gql`
    query DataWarehouseImports($options: DWI_OptionsInput) {
        dataWarehouseImports(options: $options) {
        totalCount
        edges {
            node {
            id
            importType
            docType
            status
            metadata
            startedAt
            completedAt
            createdAt
            updatedAt
            }
        }
        options {
            page
            limit
            orderBy
            orderDir
            importTypes
            docTypes
            statuses
        }
        pagination
    }
}
`;

/*
input DWI_OptionsInput {
    importTypes: (
        FULL,
        INCREMENTAL
    )[]
    docTypes: (
        BRANDS,
        BUNCHBALL_POINT_CATEGORIES,
        CATEGORIES,
        COMPANY_LOCALE_CODES,
        COURSE_CERTIFICATES,
        COURSES,
        CURRICULUMS,
        ENROLLMENTS,
        LEARNING_OBJECTS,
        LOGIN_RECORDS,
        BUNCHBALL_LOGIN_RECORDS,
        NOTIFICATIONS,
        RESOURCES,
        SEGMENTS,
        TAGS,
        USERS,
        USER_ATTRIBUTE_TYPES
    )[]
    statuses: (
        COMPLETED,
        ERROR,
        IN_PROGRESS,
        PENDING
    )[]
    page: Int
    limit: Int
    orderBy: (createdAt)
    orderDir: (
        asc,
        desc
    )

}
*/

export default DATA_WAREHOUSE_IMPORTS;
